import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const categoryImages: Record<string, string> = {
  'japan-cat': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20interior%20scene%20with%20warm%20ambient%20lighting%20and%20premium%20atmosphere%2C%20soft%20golden%20hour%20tones%2C%20modern%20architectural%20details%2C%20subtle%20geometric%20patterns%2C%20luxurious%20yet%20understated%20vibe%2C%20professional%20editorial%20quality&width=600&height=450&seq=japan-cat&orientation=landscape',
  'korea-cat': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20contemporary%20space%20with%20warm%20candlelight%20ambiance%2C%20sleek%20modern%20architecture%2C%20soft%20neutral%20color%20palette%2C%20premium%20interior%20design%2C%20subdued%20elegance%2C%20editorial%20photography%20style&width=600&height=450&seq=korea-cat&orientation=landscape',
  'sea-cat': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20tropical%20modern%20interior%20with%20warm%20sunlight%20streaming%20through%20windows%2C%20natural%20textures%2C%20bamboo%20accents%2C%20serene%20atmosphere%2C%20premium%20resort%20aesthetic%2C%20editorial%20quality&width=600&height=450&seq=sea-cat&orientation=landscape',
  'cn-cat': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20oriental%20modern%20interior%20with%20warm%20lantern%20lighting%2C%20sleek%20contemporary%20Chinese%20design%20elements%2C%20rich%20textures%2C%20premium%20atmosphere%2C%20editorial%20photography&width=600&height=450&seq=cn-cat&orientation=landscape',
};

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="category-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium mb-3">
            内容分类
          </span>
          <h2 id="category-title" className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
            <a href="#category-title">按地区浏览内容平台</a>
          </h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
            根据地区和内容类型快速筛选，找到最适合您的亚洲无码正版内容平台。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/50 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={categoryImages[cat.imageSeq] || categoryImages['japan-cat']}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-5 h-5 flex items-center justify-center text-white/80">
                    <i className={cat.icon}></i>
                  </span>
                  <h3 className="font-heading font-semibold text-white text-base">{cat.name}</h3>
                </div>
                <p className="text-white/70 text-xs line-clamp-1">{cat.nameEn}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}